var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Solid",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6886 10.1444C40.4371 10.8929 40.4371 12.1065 39.6886 12.855L18.6053 33.9383C17.8568 34.6868 16.6432 34.6868 15.8947 33.9383L6.31138 24.355C5.56287 23.6065 5.56287 22.3929 6.31138 21.6444C7.05988 20.8959 8.27345 20.8959 9.02195 21.6444L17.25 29.8724L36.978 10.1444C37.7266 9.39588 38.9401 9.39588 39.6886 10.1444Z",
    fill: "#00BB00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c3c59d3b6fb15d741d03bb961a079f95.svg";
export { ForwardRef as ReactComponent };